'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isConditionalValue = isConditionalValue;

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var UNARY_OPERATIONS = ['present', 'blank'];
var getOperands = exports.getOperands = function getOperands(operator, operands) {
  return UNARY_OPERATIONS.includes(operator) ? operands.slice(0, operands.length - 1) : operands;
};

var isValidOperand = exports.isValidOperand = function isValidOperand(el) {
  return typeof el === 'boolean' || (typeof el === 'undefined' ? 'undefined' : _typeof(el)) === 'object' && 'type' in el && 'value' in el || isConditionalValue(el);
};

var isConditionalArray = function isConditionalArray(_ref) {
  var _ref2 = _toArray(_ref),
      first = _ref2[0],
      rest = _ref2.slice(1);

  return typeof first === 'string' && getOperands(first, rest).every(isValidOperand);
};
function isConditionalValue(val) {
  return Array.isArray(val) && isConditionalArray(val);
}

var isVar = function isVar(val) {
  return val && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && val.type === 'var';
};

var getAllVarPaths = exports.getAllVarPaths = function getAllVarPaths(conditionalLogic) {
  return conditionalLogic.reduce(function (vars, val) {
    if (Array.isArray(val)) {
      return vars.concat(getAllVarPaths(val));
    } else {
      return vars.concat(isVar(val) ? [val.value] : []);
    }
  }, []);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-metadata-2/dist/conditionUtils.js
// module id = 284
// module chunks = 0